const TEACHER_ROLE_STATUS = {
    UNKNOWN: 0,
    PENDING: 1,
    REJECTED: 2,
    APPROVED: 3,
};
export default TEACHER_ROLE_STATUS;